/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Materials_TitleInputs */

const vi_pll_new_materials_title = /** @type {(inputs: Pll_New_Materials_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư đóng gói (tuỳ chọn)`)
};

/**

* @param {Pll_New_Materials_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_materials_title = /** @type {((inputs?: Pll_New_Materials_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Materials_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_materials_title(inputs)
});